import { ZipCodeValidation } from '../../../../shared/Form';

export class ZipCodeValidationCH extends ZipCodeValidation {
  constructor(errorMessage: string = 'Entered value is not a valid zip code') {
    super(/^\d{4}$/i, errorMessage);
  }
}
